<template>
  <ListItemsWithTableLayout>
    <template #body>
      <HandlerAccessDenied :is-denied="isDenied">
        <PlatformFilterForm
          :isFilterEnabled="isFilterEnabled"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          @set-filter="setFilter"
        ></PlatformFilterForm>
        <PlatformsListPanel
          @set-common-filter="setCommonFilter"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          :isFilterEnabled="isFilterEnabled"
          :isFilterSetted="isFilterSetted"
        ></PlatformsListPanel>
        <div
          id="table-container"
          class="table-container flex flex-col"
          :class="[
            filteredPlatforms && filteredPlatforms.length == 0
              ? 'empty'
              : 'filled',
          ]"
        >
          <PlatformsTable
            :platforms="filteredPlatforms"
            :isActiveFirst="activeFirstFromStore"
            :isLoading="isLoading"
            :rowsCount="rowsCount(43) * tableDisplaySettings.first"
            @sort-table="sortTable"
            @update-table="updatePlatformsList"
          ></PlatformsTable>
          <EmptyTableMessage
            v-if="
              filteredPlatforms && filteredPlatforms.length == 0 && !isLoading
            "
          >
            <template #text>
              Примените другой фильтр или создайте первую рекламную площадку.
              <br />
              Для этого кликните на кнопку "Создать рекламный кабинет".
            </template>
          </EmptyTableMessage>
        </div>
        <Paginator
          v-model:first="tableDisplaySettings.first"
          @update:first="updatePlatformsList"
          :rows="1"
          class="s-paginator"
          :totalRecords="store.platformsPagesCount"
          template="PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="{first} из {totalRecords}"
        />
      </HandlerAccessDenied>
    </template>
  </ListItemsWithTableLayout>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";

import Paginator from "primevue/paginator";
import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import PlatformsListPanel from "@/entities/dictionaries/platforms/panels/PlatformsListPanel.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import PlatformsTable from "@/entities/dictionaries/platforms/PlatformsTable.vue";
import PlatformFilterForm from "@/entities/dictionaries/platforms/forms/PlatformFilterForm.vue";

import {
  usePlatformsStore,
  PlatformsParams,
} from "@/store/dictionaries/platforms";
import { useAuthStore } from "@/store/auth/login";
import { rowsCount } from "@/services/utils/Pagination";
import { setPlatformsParamsByFilter } from "@/services/dictionaries/platforms";
import { FilterForm } from "@/services/dictionaries/platforms";

const store = usePlatformsStore();
const authStore = useAuthStore();
const isLoading = ref(false);
const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  commonFilter: "",
  filter: {} as FilterForm,
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["dictionaries:read", "dictionaries:edit"]
  );
});

const filteredPlatforms = computed(() => {
  return store.platformsList;
});

const activeFirstFromStore = computed(() => store.activeFirst);

onMounted(() => {
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  updatePlatformsList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  updatePlatformsList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updatePlatformsList();
};

const setFilter = (filter: FilterForm, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updatePlatformsList();
};

const updatePlatformsList = () => {
  let isEnded = false;
  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);
  const params: PlatformsParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(43),
  };

  setPlatformsParamsByFilter(params, tableDisplaySettings.value);

  store.getPlatforms(params).finally(() => {
    isLoading.value = false;
    isEnded = true;
  });
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updatePlatformsList, 200);
});
</script>
